import { FightEventFlag } from 'web/data/models'
import React from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faSun, faRunning, faExpandArrowsAlt, faTint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { WithTooltip } from '../generic/WithTooltip'
import { dataTest } from 'web/utils/test-utils'

export const EventFlags: React.FC<{ flags: FightEventFlag[] }> = ({ flags }) => {

    return (
        <WithTooltip place="top">
            {ttId => (
                <div className="d-flex space-mx-2 ml-2">
                    {flags.map(flag => {

                        let faIcon: IconDefinition | undefined
                        let tipText = ""

                        switch (flag) {
                            case FightEventFlag.Movement: {
                                faIcon = faRunning
                                tipText = "Movement"
                                break
                            }
                            case FightEventFlag.Burst: {
                                faIcon = faSun
                                tipText = "Burst damage"
                                break
                            }
                            case FightEventFlag.Rot: {
                                faIcon = faTint
                                tipText = "Rot damage"
                                break
                            }
                            case FightEventFlag.Spread: {
                                faIcon = faExpandArrowsAlt
                                tipText = "Spread out"
                                break
                            }

                            // Not rendered symbols, changes text rendering
                            case FightEventFlag.Emphasize: {
                                return null
                            }
                            case FightEventFlag.Muted: {
                                return null
                            }

                            default: {
                                throw Error(`Unhandled event-flag: ${flag}`)
                            }
                        }

                        return (
                            <FontAwesomeIcon
                                data-test={dataTest('event-flag-icon', flag)}
                                data-for={ttId}
                                data-tip={tipText}

                                size="xs"
                                key={flag}
                                icon={faIcon}
                                fixedWidth
                            />
                        )
                    })}
                </div>
            )}
        </WithTooltip>
    )
}
